// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"58":"2c2bd56c","97":"9b8de6bc","166":"81e78047","249":"1b51ba1e","421":"d5347b1c","584":"9d0b8df4","938":"ed81cdab"}[chunkId] + ".js";
};